import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Post } from '../container';
import { FirestoreService } from '../firestore-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-workpackagesearchpopup',
    templateUrl: './workpackagesearchpopup.component.html',
    styleUrl: './workpackagesearchpopup.component.scss',
    standalone: true,
    imports: [CommonModule, FormsModule],
})
export class WorkpackagesearchpopupComponent {
  @Input() organizationKey: string = ""
  @Input() projectKey: string = ""
  @Input() userId: string = ""
  @Input() userEmail: string = ""
  @Input() userName: string = ""
  @Input() canAddNewContent: boolean = false
  @Output() foundContent = new EventEmitter<{"key": string, "name": string, "htmlName": string, "color": string, "coverImageURL": string}[]>();
  @Output() addNewWorkpackage = new EventEmitter<void>();
  showModal = true
  workpackages: Post[] = []
  workpackagesBeforeFiltering: Post[] = [] // array of all posts before filtering, used to recover posts when filtering is cleared without reloading
  userQuery = ""
  message = ""

  showFavouriteOnly = false

  constructor(private firestore: FirestoreService) {

  }

  ngAfterViewInit() {
    setTimeout(() => { // it must be wrapped with setTimeout to avoid error
      this.loadWorkpackages()
    })
  }

  filterOnInputChange(value: string) { // detect that user cleared filtering input field
    if (value.trim() === '') {
      this.filterPosts("")
    }
  }

  showFavourite(showOnly: boolean) {
    this.showFavouriteOnly = showOnly
    this.filterPosts(this.userQuery)
  }

  filterPosts(searchQuery: string) { // filters posts by keywords
    this.message = "Searching posts..."
    if (searchQuery != "") { // if user didn't enter text, then don't filter
      const searchWords: string[] = searchQuery.toLowerCase().split(/[,\s.:-;\n]+/);
      this.workpackages = this.workpackagesBeforeFiltering.filter((obj: Post) => {
        return searchWords.some((word: string) => (obj.name.toLowerCase() || '').includes(word));
      }).map(obj => ({...obj}));
    } else { // if user entered text, then filter
      this.workpackages = this.workpackagesBeforeFiltering.map(obj => ({...obj}));
    }
    if (this.workpackages.length == 0) {
      this.message = "No matching content found."
    }
  }

  loadWorkpackages() {
    this.workpackages.length = 0
    this.message = "Loading content..."
    this.firestore.getWorkpackages(this.organizationKey, this.projectKey).then((result) => {
      result.forEach((wp) => {
        if (wp.name == undefined) {
          wp.name = ""
        }
        if (wp.nameHTML == undefined) {
          wp.nameHTML = ""
        }
        if (wp.name == "" && wp.nameHTML == "") {
          wp.name = "Untitled"
          wp.nameHTML = "Untitled"
        }
        if (wp.nameHTML == "") {
          wp.nameHTML = wp.name
          }
          if (wp.name == "") {
            wp.name = wp.nameHTML
          }
          this.workpackages.push(wp)
      })
      this.workpackages = [...result]
      if (this.workpackages.length == 0) {
        this.message = "No matching content found"
      }
      this.workpackagesBeforeFiltering = this.workpackages.map(obj => ({...obj}));
    })
  }
  
    closeModal() { // closing modal window is done by changing parameter showModal on parent component
      this.foundContent.emit([]);
    }

    checkName(key: string) {
      const i = this.getPostByKey(key)
      if (i > -1) {
        this.workpackages[i].isChecked = !this.workpackages[i].isChecked
      }
    }

    getPostByKey(key: string) {
      for (let i = 0; i < this.workpackages.length; ++i) {
        if (this.workpackages[i].key == key) {
          return i
        }
      }
      return -1
    }

    addWorkpackages() {
      const workpackages: {"key": string, "name": string, "htmlName": string, "color": string, "coverImageURL": string}[] = []
      for (let i = 0; i < this.workpackages.length; i++) {
        if (this.workpackages[i].isChecked == true) {
          workpackages.push({"key": this.workpackages[i].key, "name": this.workpackages[i].nameHTML, "htmlName": this.workpackages[i].nameHTML, "color": this.workpackages[i].color, "coverImageURL": this.workpackages[i].coverImageURL})
        }
      }
      this.foundContent.emit(workpackages);
    }

    sendAddNewPost() {
    //  this.addNewPost.emit()
    }
}
